<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8" fluid>
          <v-row>
            <v-col cols="3">
              <v-text-field density="compact" variant="outlined" hide-details="auto" v-model="searchCondition.loginId"
                :label="$t('user.label.loginId')" />
            </v-col>
            <v-col cols="3">
              <v-text-field density="compact" variant="outlined" hide-details="auto" v-model="searchCondition.name"
                :label="$t('user.label.name')" />
            </v-col>
            <v-col cols="3">
              <v-select density="compact" variant="outlined" hide-details="auto" v-model="searchCondition.role"
                :items="roleItem" item-title="code_name" item-value="code" :label="$t('user.label.role')" return-object :clearable="true" />
            </v-col>
            <v-col cols="3">
              <!-- 店舗の一覧から選ぶ（店舗コード・店舗名を打つと候補が絞られる）。選んだ店舗コードで検索する（2026-10-22）。
                   店舗は複数選べ、どれかにログインできるユーザーを出す。「全店舗」（または未選択）は店舗で絞らない（2026-10-24）。
                   auto-select-first は付けない。付けると打ち込んだときに先頭の店舗が強調され、選ばれたように見える（2026-11-01 打合せ・S-41。棚卸画面に合わせる） -->
              <v-autocomplete density="compact" variant="outlined" hide-details="auto"
                v-model="searchCondition.possibleToLogInStores" @update:model-value="shopSearchGuard.selected"
                :search="shopSearch" @update:search="onShopSearch" :items="shopOptionsShown" item-title="code_name" item-value="code"
                multiple chips closable-chips
                :label="$t('user.label.possibleToLogInStore')" :clearable="true" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn text @click="clear">{{ $t('common.action.clear') }}</v-btn>
              <v-btn theme="dark" class="ml-4 px-8 bg-grey-darken-3" elevation="2" @click.prevent="search"
                :loading="isSearching">{{ $t('common.action.search') }}</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn dark class="bg-indigo-darken-1" elevation="2" @click="showDialog4Register">{{ $t('user.action.register') }}</v-btn>
              <v-btn dark class="ml-4 bg-indigo-darken-1" elevation="2" @click="onCsvUploadBtnClick">{{ $t('user.action.loadCsv') }}</v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-table density="compact" class="text-no-wrap">
                <thead>
                  <tr>
                    <th v-for="header in headers" :key="header" @click.stop="tableSort(header)"
                      :style="cursorCheck(header)">{{ $t("user.label.table." + header) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in filteredDataList" :key="data.no"
                    v-bind:style="{ backgroundColor: data.status == constant.USER_STATUS.INVALID ? 'lightgray' : '' }">
                    <template v-for="header in headers" :key="header">

                      <template v-if="header == 'role'">
                        <td>{{ this.getRoleByUser(data).label }}</td>
                      </template>

                      <template v-else-if="header == 'update'">
                        <td v-if="data.status == constant.USER_STATUS.VALID">
                          <v-btn size="small" @click="showDialog4Change(data)" color="blue">{{ $t('user.action.modify') }}</v-btn>
                        </td>
                        <td v-else></td>
                      </template>

                      <template v-else-if="header == 'activate'">
                        <td v-if="data.status == constant.USER_STATUS.VALID">
                          <v-btn size="small" @click="showDialog4Activate(data)">{{ $t('user.action.disable') }}</v-btn>
                        </td>
                        <td v-else>
                          <v-btn size="small" @click="showDialog4Activate(data)" color="green">{{ $t('user.action.enable') }}</v-btn>
                        </td>
                      </template>

                      <template v-else-if="header == 'possibleToLogInStoreList'">
                        <td>
                          <template v-if="data.isSysAdmin">
                            {{ $t('user.label.allSite') }}
                          </template>
                          <template v-else v-for="store in data.possibleToLogInStoreList" :key="store">
                            {{ store.storeName }}<br />
                          </template>
                        </td>
                      </template>

                      <template v-else>
                        <td>{{ data[header] }}</td>
                      </template>
                    </template>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3"></v-col>
            <v-col cols="6">
              <v-pagination v-model="currentPageNo" :length="maxPageNo" />
            </v-col>
            <v-col cols="3">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="10" class="d-flex justify-end">
                  <v-select density="compact" variant="outlined" hide-details="auto" v-model="displayPerPage"
                    :items="displayPerPageItem" item-title="name" item-value="value" :label="$t('common.label.displayCountPerPage')"
                    @update:modelValue="resetCondition()" return-object />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="text-right">
                  {{displayContentNo.minNo}} - {{displayContentNo.maxNo}}{{ $t('common.label.displayedDataRange') }} / {{ dataList.length }}{{ $t('common.label.totalCountOf') }}
                </v-col>
              </v-row>

            </v-col>
          </v-row>
        </v-container>
        <UserRegisterDialog v-if="registerDialogVisible" :dialog-data="registerDialog" :handle-ok="confirmRegisterOk"
          :handle-cancel="confirmRegisterCancel" />
        <UserActivateDialog v-if="activateDialogVisible" :dialog-data="activateDialog" :handle-ok="confirmActivateOk"
          :handle-cancel="confirmActivateCancel" />
        <ZeroData v-if="zeroDataWarningDialogFlg" :handle-ok="closeZeroDataDialog" />
        <!-- CSV取込は、形式と記入例を見せる画面を挟んでから取り込む（サーバー修正 S-40） -->
        <UserCsvImportDialog v-if="csvImportDialogVisible" :handle-cancel="() => (csvImportDialogVisible = false)"
          :handle-import="importCsv" :importing="isImportingCsv" />
        <MessageDialog v-if="commonMsgDlgVisible" :dialog-data="data4MsgDialog" :handle-ok="closeMessageDataDialog" />
        <!-- CSV取込の結果（件数と誤りのあった行。誤りの行はCSVで出せる。JCIKAIHATSU-496 2026-11-03） -->
        <ImportResultDialog v-if="importResult" :title="$t('userCsvImportDialog.label.title')" :file-name="importResult.fileName"
          :result="importResult.result" :error-message="importResult.errorMessage" :handle-close="() => (importResult = null)" />
      </v-main>
    </AppWrapperView>
  </v-app>
</template>

<script lang="js">
import api from "@/apis/staff";
import utils from "@/utils";
import constant from "@/utils/constant";
import AppWrapperView from "@/components/views/AppWrapperView";
import MessageDialog from "@/components/dialog/MessageDialog";
import UserRegisterDialog from "@/components/dialog/UserRegisterDialog";
import UserActivateDialog from "@/components/dialog/UserActivateDialog";
import UserCsvImportDialog from "@/components/dialog/UserCsvImportDialog";
import ImportResultDialog from "@/components/dialog/ImportResultDialog";
import ZeroData from "@/components/dialog/ZeroDataDialog";
import store from "@/store";
import { withAllShops, isAllShops, normalizeShopSelection, selectedShopCodes, limitShopOptions, createShopSearchGuard } from "@/utils/shopSelection";

export default {
  components: { AppWrapperView, UserRegisterDialog, ZeroData, MessageDialog, UserActivateDialog, UserCsvImportDialog, ImportResultDialog, },
  props: {},
  watch: {
    // 「全店舗」と個別の店舗を同時に選ばないよう直す（2026-10-24）
    "searchCondition.possibleToLogInStores"(value, oldValue) {
      const fixed = normalizeShopSelection(value, oldValue);
      if (fixed !== value) this.searchCondition.possibleToLogInStores = fixed;
    },
  },
  computed: {
    constant() {
      return constant;
    },
    // ログイン可能店舗の候補（先頭に「全店舗」。2026-10-24）
    shopOptions() {
      return withAllShops(this.shopList, this.$t('common.label.allShops'));
    },
    // 欄に渡す候補（打った文字に当たる先頭100件＋全店舗＋選択済み。2026-10-26 S-32）
    shopOptionsShown() {
      return limitShopOptions(this.shopOptions, this.shopSearch, this.searchCondition.possibleToLogInStores);
    },
    // ソート処理
    sortedTable() {
      let tempArray = this.dataList.map(x => x);
      // ロールの場合
      if (this.sortState.target == "role") {
        return tempArray.sort(this.roleSorter(this.sortState.ascent));
      }
      // ログイン可能店舗
      if (this.sortState.target == "possibleToLogInStoreList") {
        return tempArray.sort(this.storeListSorter(this.sortState.ascent));
      }
      // その他
      if (this.sortState.target != "") {
        return tempArray.sort(this.defaultSorter(this.sortState.ascent));
      }
      return tempArray;
    },
    // ページング関連処理 START ====================================
    // どの部分を表示しているのかを表示
    displayContentNo() {
      const minNo = this.dataList.length != 0 ? 1 + (this.displayPerPage.value * (this.currentPageNo - 1)) : 0;
      const maxNo = this.displayPerPage.value * (this.currentPageNo);
      if (maxNo > this.dataList.length || this.displayPerPage.value == 0) {
        return { minNo: minNo, maxNo: this.dataList.length };
      }
      return { minNo: minNo, maxNo: maxNo };
    },
    // 最大ページ
    maxPageNo() {
      if (this.displayPerPage.value == 0) return 0;
      return Math.ceil(this.dataList.length / this.displayPerPage.value);
    },
    // ページ区切り後のデータ
    filteredDataList() {
      const tempArray = this.sortedTable;
      return tempArray.slice(this.displayContentNo.minNo - 1, this.displayContentNo.maxNo);
    },
    // ヘッダー
    headers() {
      return this.$getTableDef("UserPage");
    },
  },

  data: () => ({
    // 表示ページ
    currentPageNo: 1,
    //１ページ表示数
    displayPerPage: {},
    displayPerPageItem: [],
    // ソートの状態
    sortState: { target: "", ascent: true },
    // ロールリスト
    roleItem: [],
    // 店舗リスト
    shopList: [],
    // 店舗の欄に打っている文字（候補の絞り込み用）
    shopSearch: "",
    // 店舗を選んだ直後に打った文字が消えないようにする（createShopSearchGuard）
    shopSearchGuard: createShopSearchGuard(),
    // 検索結果格納
    dataList: [],
    // 検索条件
    searchCondition: {
      loginId: "",                // ログインID
      name: "",                   // 名前
      role: null,                 // ロール
      possibleToLogInStores: [],  // ログイン可能店舗（複数。「全店舗」は ALL_SHOPS。2026-10-24）
    },
    // 検索中
    isSearching: false,
    // 登録ダイアログ表示フラグ
    registerDialogVisible: false,
    // ユーザ登録ダイアログに渡すデータ
    registerDialog: {
      user: null,
    },
    // 有効無効ダイアログ表示フラグ
    activateDialogVisible: false,
    // 有効無効ダイアログに渡すデータ
    activateDialog: {
      user: null,
    },
    // 0件取得時の警告ダイアログ
    zeroDataWarningDialogFlg: false,
    // 汎用メッセージダイアログ
    commonMsgDlgVisible: false,
    csvImportDialogVisible: false,
    // CSV取込の送信中
    isImportingCsv: false,
    // CSV取込の結果（{ fileName, result, errorMessage }）。null なら出さない
    importResult: null,
    data4MsgDialog: {
      message: "",
      errorList: [],
    },
  }),

  methods: {
    // 店舗欄の打った文字。店舗を選んだ直後に Vuetify が消すのは受け付けない（createShopSearchGuard）
    onShopSearch(value) {
      if (this.shopSearchGuard.accepts(value)) this.shopSearch = value;
    },
    //テーブルの条件リセット
    resetCondition() {
      this.currentPageNo = 1;
      this.sortState.target = "";
      this.sortState.ascent = true;
    },
    // ユーザ情報から権限のIDを返却
    getRoleByUser(user) {
      let role = null;
      // Admin 以外はすべて店舗ユーザ（ゾーンマネージャは 2026-10-27 に削除。S-03）
      if (user.isSysAdmin) {
        role = this.roleItem.find(e => e.code == constant.ROLE.ADMIN.id);
      } else {
        role = this.roleItem.find(e => e.code == constant.ROLE.SITE_USER.id);
      }
      return {id: role.code, label: role.name};
    },
    // カーソルの変更
    cursorCheck() {
      return "cursor: pointer;"
    },
    // ロールリスト設定
    getRoleList() {
      this.roleItem = [];
      utils.getRoleList(this.$t).forEach(element => {
        this.roleItem.push({ name: element.label, code: element.id, code_name: element.label })
      })
    },
    // 検索条件クリア
    clear() {
      this.searchCondition = {
        loginId: "",                // ログインID
        name: "",                   // 名前
        role: null,                 // ロール
        possibleToLogInStores: [],  // ログイン可能店舗
      }
    },
    // 検索処理
    // showZeroDialog: 0件のときにダイアログを出すか（画面を開いたときの自動表示では出さない）
    search(showZeroDialog = true) {
      this.isSearching = true;
      api.post("/user/search", {
        loginId: this.searchCondition.loginId,
        name: this.searchCondition.name,
        role: this.searchCondition.role?.code ?? "",
        // 「全店舗」・未選択なら店舗で絞らない
        possibleToLogInStoreList: isAllShops(this.searchCondition.possibleToLogInStores)
          ? null
          : selectedShopCodes(this.searchCondition.possibleToLogInStores, this.shopList),
      })
        .then((response) => {
          this.dataList = response.data.results?.userList ?? [];
          this.resetCondition();
          // 0件ダイアログ処理
          if (this.dataList.length == 0 && showZeroDialog) this.zeroDataWarningDialogFlg = true;
          this.isSearching = false;
        })
        .catch(() => {
          // 0件 dialog
          this.dataList = [];
          if (showZeroDialog) this.zeroDataWarningDialogFlg = true;
          this.isSearching = false;
        })
    },
    // ソート関連処理 START ================================================
    // ソート
    tableSort(headValue) {
      if (headValue == "no") return;
      if (this.sortState.target == headValue) {
        this.sortState.ascent = !this.sortState.ascent;
      } else {
        this.sortState.target = headValue;
        this.sortState.ascent = true;
      }
    },
    // 汎用的なソート関数を返却する
    defaultSorter(isAscent) {
      // a,b はユーザ情報が格納されているとする
      return (a, b) => {
        const multiplier = isAscent ? 1 : -1;
        if (a[this.sortState.target] > b[this.sortState.target]) return 1 * multiplier;
        if (a[this.sortState.target] < b[this.sortState.target]) return -1 * multiplier;
        return 0;
      }
    },
    // 権限に対するソート関数を返却する
    roleSorter(isAscent) {
      // a,b はユーザ情報が格納されているとする
      return (a, b) => {
        const multiplier = isAscent ? 1 : -1;
        if (this.getRoleByUser(a).id > this.getRoleByUser(b).id) return 1 * multiplier;
        if (this.getRoleByUser(a).id < this.getRoleByUser(b).id) return -1 * multiplier;
        return 0;
      }
    },
    // ログイン可能店舗に対するソート関数を返却する
    storeListSorter(isAscent) {
      // a,b はユーザ情報が格納されているとする
      return (a, b) => {
        const getRefVal = (user) => {
          if (user.isSysAdmin) return this.$t('user.label.allSite');
          if (user.possibleToLogInStoreList.length != 0) {
            return user.possibleToLogInStoreList[0].storeName;
          }
          return "";
        };
        const multiplier = isAscent ? 1 : -1;
        if (getRefVal(a) > getRefVal(b)) return 1 * multiplier;
        if (getRefVal(a) < getRefVal(b)) return -1 * multiplier;
        return 0;
      }
    },
    // 汎用ダイアログ関連処理 START ========================================
    // 0件ダイアログを閉じる
    closeZeroDataDialog() {
      this.zeroDataWarningDialogFlg = false;
    },
    // 共通メッセージダイアログを閉じる
    closeMessageDataDialog() {
      this.commonMsgDlgVisible = false;
    },
    // 新規登録ダイアログ関連処理 START ====================================
    // 登録ダイアログ表示
    showDialog4Register() {
      this.showDialogCommonRegister(null, 'new');
    },
    // 更新ダイアログ表示
    showDialog4Change(user) {
      this.showDialogCommonRegister(user, 'upd');
    },
    // 登録/更新ダイアログ表示
    showDialogCommonRegister(user, mode) {
      this.registerDialogVisible = true;
      this.registerDialog.user = user;
      this.registerDialog.mode = mode;
      this.registerDialog.shopList = this.shopList;
    },
    // 登録/更新ダイアログ非表示
    closeRegisterDialog() {
      this.registerDialogVisible = false;
      this.registerDialog.user = null;
    },
    // 登録/更新ダイアログキャンセル
    confirmRegisterCancel() {
      this.closeRegisterDialog();
    },
    // 登録/更新ダイアログOK押下
    confirmRegisterOk() {
      this.closeRegisterDialog();
      this.search();
    },
    // 有効無効切り替えダイアログ関連処理 START ============================
    // ダイアログ表示
    showDialog4Activate(data) {
      this.activateDialogVisible = true;
      this.activateDialog.user = data;
    },
    // ダイアログ非表示
    closeActivateDialog() {
      this.activateDialogVisible = false;
      this.activateDialog.user = null;
    },
    // ダイアログキャンセル
    confirmActivateCancel() {
      this.closeActivateDialog();
    },
    confirmActivateOk() {
      this.closeActivateDialog();
      this.search();
    },
    // CSV取込関連処理 START ===============================================
    // CSV取込ボタン押下。取込画面（形式と記入例）を開く
    onCsvUploadBtnClick() {
      this.csvImportDialogVisible = true;
    },
    // CSV取込本処理（取込画面で「取込」を押したとき）
    // 取込中は取込画面を開いたまま「取込」をくるくるにし、終わってから閉じる。
    // 通信が切れたとき（タイムアウトなど）も何も出ないまま終わっていたので、メッセージを出す（受入テスト #23）
    async importCsv(file) {
      this.isImportingCsv = true;
      let formData = new FormData();
      formData.append("file", file);
      api.postFile("/user/loadcsv", formData)
        .then((response) => {
          // 読込件数と誤りのあった行が返ってきたら、取込結果の画面で見せる（JCIKAIHATSU-496 2026-11-03）。
          // ファイルを読めなかったとき（見出しの誤りなど）は返らないので、これまでどおりメッセージで出す
          if (response.data.importResult) {
            const ok = response.data.status == constant.RESPONSE_STATUS.SUCCESS;
            this.importResult = {
              fileName: file.name,
              result: response.data.importResult,
              errorMessage: ok ? "" : response.data.errorMessage,
            };
            this.search();
            return;
          }
          this.data4MsgDialog = {};
          this.data4MsgDialog.errorList = utils.limitErrorList(response.data.errorList, this.$t);
          this.data4MsgDialog.message =
            (response.data.status == constant.RESPONSE_STATUS.SUCCESS) ? this.$t('user.message.successLoadCsv') : response.data.errorMessage
          this.commonMsgDlgVisible = true;
          this.search();
        })
        .catch((error) => {
          console.log(error);
          // 通信が切れてもサーバーでは取込が終わっていることがあるので、一覧で確かめるよう案内する
          // （ここで一覧を読み直すと、サーバーが止まっているときに別のエラーが重なって出る）
          this.data4MsgDialog = {
            message: error.response?.data?.errorMessage || this.$t('user.message.loadCsvNoResult'),
            errorList: [],
          };
          this.commonMsgDlgVisible = true;
        })
        .finally(() => {
          this.isImportingCsv = false;
          this.csvImportDialogVisible = false;
        });
    },
  },
  created() {
    this.getRoleList()
  },
  mounted() {
    this.displayPerPage = utils.getDisplayPerPage(this.$t)
    this.displayPerPageItem = utils.getDisplayPerPageItem(this.$t);
    // 店舗リスト取得
    api.post("/store/search/all", {})
      .then((response) => {
        if (response.status == constant.RESPONSE_STATUS.FAILURE) return; //do nothing
        this.shopList = [];
        response.data.results?.shopList.forEach(element => {
          this.shopList.push({ name: element.name, code: element.code, code_name: element.code + '_' + element.name })
        })
      })
      .catch(() => {
        //do nothing
      })
    // 「検索」を押さなくても、条件なし（全ユーザー）で一覧を出す（2026-10-24）
    this.search(false);
  },
};
</script>
